/* src/app/components/login/login.component.scss */
.login-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f6fa;
  font-family: "Outfit";
  color: #111827;
}
.login-shell {
  width: 100%;
  min-height: 100vh;
  display: grid;
  grid-template-columns: 50% 50%;
  overflow: hidden;
  background: #ffffff;
  box-shadow: 0 20px 60px rgba(37, 59, 128, 0.1), 0 4px 16px rgba(15, 23, 42, 0.05);
}
.login-visual {
  position: relative;
  overflow: hidden;
  background: #dfe8fa;
  color: #ffffff;
}
.login-visual::before,
.login-visual::after {
  content: "";
  position: absolute;
  border-radius: 50%;
}
.login-visual::before {
  top: -180px;
  left: -180px;
  width: 420px;
  height: 420px;
  background: rgba(255, 255, 255, 0.07);
}
.login-visual::after {
  right: -170px;
  bottom: -170px;
  width: 360px;
  height: 360px;
  background: rgba(255, 255, 255, 0.06);
}
.visual-content {
  position: relative;
  z-index: 2;
  height: 100%;
  min-height: 690px;
  display: flex;
  flex-direction: column;
  padding: 27px 44px 32px;
}
.visual-brand {
  display: flex;
  align-items: center;
}
.visual-brand img {
  width: 225px;
  max-width: 100%;
  height: auto;
  filter: brightness(0) invert(1);
}
.visual-image {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 10px;
}
.visual-image img {
  width: 100%;
  max-width: 440px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.12));
}
.visual-footer {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding-top: 20px;
}
.visual-footer span {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #253b80;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
}
.visual-footer i {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}
.login-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
}
.login-content {
  width: 100%;
  max-width: 470px;
  padding: 50px 48px;
}
.mobile-brand {
  margin-bottom: 32px;
}
.mobile-brand img {
  width: 250px;
  height: auto;
}
.login-header {
  margin-bottom: 34px;
}
.login-header h2 {
  margin: 0 0 10px;
  font-size: 32px;
  line-height: 1.2;
  font-weight: 700;
  color: #111827;
}
.login-header p {
  margin: 0;
  font-size: 16px;
  line-height: 1.6;
  color: #6b7280;
}
.login-eyebrow {
  display: inline-block;
  margin-bottom: 10px;
  color: #253B80;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  letter-spacing: 0.02em;
}
.login-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 24px;
  padding: 14px 16px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: #fef2f2;
  color: #991b1b;
}
.alert-icon {
  flex: 0 0 auto;
  font-size: 18px;
  line-height: 1.4;
}
.alert-content {
  flex: 1;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
}
.alert-close {
  padding: 2px;
  border: 0;
  background: transparent;
  color: #991b1b;
  cursor: pointer;
  font-size: 14px;
}
.alert-close:hover {
  opacity: 0.7;
}
.login-form {
  width: 100%;
}
.form-field {
  margin-bottom: 24px;
}
.form-field > label {
  display: block;
  margin-bottom: 9px;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
}
.field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 9px;
}
.field-header label {
  display: block;
  margin-bottom: 0;
  color: #1f2937;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
}
.forgot-link {
  color: #253B80;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
}
.forgot-link:hover {
  color: #1d2f68;
  text-decoration: underline;
}
.input-wrapper {
  position: relative;
  width: 100%;
}
.input-icon {
  position: absolute;
  top: 50%;
  left: 16px;
  z-index: 2;
  transform: translateY(-50%);
  color: #7b8494;
  font-size: 17px;
  pointer-events: none;
}
.form-input {
  width: 100%;
  min-height: 52px;
  padding: 12px 16px 12px 48px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  outline: none;
  background: #ffffff;
  color: #111827;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.5;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}
.form-input::placeholder {
  color: #9ca3af;
  font-size: 14px;
}
.form-input:hover {
  border-color: #aeb5c0;
}
.form-input:focus {
  border-color: #253B80;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(37, 59, 128, 0.12);
}
.password-input {
  padding-right: 52px;
}
.password-toggle {
  position: absolute;
  top: 50%;
  right: 8px;
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  font-size: 17px;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.password-toggle:hover {
  background: #f1f4fa;
  color: #253B80;
}
.login-button {
  width: 100%;
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 4px;
  padding: 12px 18px;
  border: 0;
  border-radius: 10px;
  background: #253B80;
  color: #ffffff;
  font-family: "Outfit";
  font-size: 15px;
  line-height: 1.5;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    transform 0.15s ease,
    box-shadow 0.2s ease;
}
.login-button:hover:not(:disabled) {
  background: #1d2f68;
  box-shadow: 0 8px 20px rgba(37, 59, 128, 0.2);
  transform: translateY(-1px);
}
.login-button:active:not(:disabled) {
  transform: translateY(0);
}
.login-button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
.login-button i {
  font-size: 15px;
}
.login-button.loading {
  cursor: wait;
  opacity: 0.85;
}
.spinner-border {
  width: 17px;
  height: 17px;
  border-width: 2px;
}
.signup-section {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 28px;
  color: #6b7280;
  font-size: 14px;
  line-height: 1.6;
}
.signup-link {
  color: #253B80;
  font-family: "Outfit";
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
.signup-link:hover {
  color: #1d2f68;
  text-decoration: underline;
}
.login-security {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 30px;
  padding-top: 22px;
  border-top: 1px solid #eef0f4;
  color: #7b8494;
  text-align: center;
}
.login-security i {
  flex: 0 0 auto;
  color: #253B80;
  font-size: 14px;
}
.login-security span {
  font-size: 13px;
  line-height: 1.5;
}
.auto-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: #f4f6fa;
}
.auto-login-card {
  width: 100%;
  max-width: 420px;
  padding: 44px 40px;
  border: 1px solid #e6e9ef;
  border-radius: 20px;
  background: #ffffff;
  text-align: center;
  box-shadow: 0 20px 60px rgba(37, 59, 128, 0.1);
}
.auto-login-card h4 {
  margin: 0 0 8px;
  color: #111827;
  font-family: "Outfit";
  font-size: 22px;
  line-height: 1.4;
}
.auto-login-card p {
  margin: 0;
  color: #6b7280;
  font-size: 15px;
  line-height: 1.6;
}
.animation-wrapper {
  width: 180px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}
.animation-wrapper canvas {
  max-width: 100%;
  max-height: 100%;
}
.progress-line {
  width: 100%;
  height: 4px;
  margin-top: 26px;
  overflow: hidden;
  border-radius: 999px;
  background: #e8edf7;
}
.progress-line span {
  display: block;
  width: 40%;
  height: 100%;
  border-radius: inherit;
  background: #253B80;
  animation: loginProgress 1.6s ease-in-out infinite;
}
@keyframes loginProgress {
  0% {
    transform: translateX(-120%);
  }
  50% {
    transform: translateX(120%);
  }
  100% {
    transform: translateX(280%);
  }
}
@media (max-width: 991.98px) {
  .login-page {
    padding: 20px;
  }
  .login-shell {
    max-width: 620px;
    min-height: auto;
    display: block;
    border-radius: 20px;
  }
  .login-visual {
    display: none;
  }
  .login-panel {
    min-height: calc(100vh - 40px);
    align-items: center;
  }
  .login-content {
    max-width: 480px;
    padding: 45px 40px;
  }
  .mobile-brand {
    display: block;
  }
  .login-header h2 {
    font-size: 30px;
  }
}
@media (max-width: 575.98px) {
  .login-page {
    padding: 0;
    background: #ffffff;
  }
  .login-shell {
    min-height: 100vh;
    border-radius: 0;
    box-shadow: none;
  }
  .login-panel {
    min-height: 100vh;
    align-items: flex-start;
  }
  .login-content {
    max-width: none;
    padding: 32px 22px;
  }
  .mobile-brand {
    margin-bottom: 40px;
  }
  .mobile-brand img {
    width: 150px;
  }
  .login-header {
    margin-bottom: 30px;
  }
  .login-header h2 {
    font-size: 27px;
    line-height: 1.25;
  }
  .login-header p {
    font-size: 15px;
  }
  .login-eyebrow {
    font-size: 13px;
  }
  .form-field {
    margin-bottom: 22px;
  }
  .form-field > label {
    font-size: 14px;
  }
  .field-header label {
    font-size: 14px;
  }
  .form-input,
  .login-button {
    min-height: 52px;
  }
  .form-input {
    font-size: 15px;
  }
  .login-button {
    font-size: 15px;
  }
  .signup-section {
    margin-top: 26px;
    font-size: 14px;
  }
  .login-security {
    margin-top: 26px;
  }
  .login-security span {
    font-size: 12px;
  }
  .auto-login {
    padding: 20px;
  }
  .auto-login-card {
    padding: 36px 24px;
    border-radius: 16px;
  }
  .auto-login-card h4 {
    font-size: 20px;
  }
  .auto-login-card p {
    font-size: 14px;
  }
}
@media (max-width: 375px) {
  .login-content {
    padding: 28px 18px;
  }
  .login-header h2 {
    font-size: 24px;
  }
  .login-header p {
    font-size: 14px;
  }
  .field-header {
    align-items: flex-start;
    gap: 10px;
  }
  .forgot-link {
    font-size: 13px;
  }
}
/*# sourceMappingURL=login.component.css.map */
